import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const loggedIn = useSelector(state => state.authentication.loggedIn);
  const sessionChecked = useSelector(state => state.authentication.sessionChecked);
  const loggingOut = useSelector(state => state.authentication.loggingOut);
  const user = useSelector(state => state.authentication.user);
  if (!sessionChecked) return null;
  return (
    <Route
      {...rest}
      render={({ location }) =>
        loggedIn && !loggingOut && user ? (
          <Component />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: location } }} />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  location: PropTypes.object,
};

export default PrivateRoute;
